import React from 'react';

import type { ImageFetchProps } from '../../model/types';

import styles from './BannerImage.scss';

interface BannerImageProps extends ImageFetchProps {
  image?: string;
}

const BannerImage: React.FC<BannerImageProps> = ({ image, priority }) =>
  image ? (
    <img
      className={styles.image}
      src={image}
      alt=""
      loading={priority === 'high' ? 'eager' : 'lazy'}
      // eslint-disable-next-line react/no-unknown-property
      fetchPriority={priority}
    />
  ) : null;

export default BannerImage;
